// extracted by mini-css-extract-plugin
export var accordion = "_d2-0";
export var chevron = "_d2-3";
export var closed = "_d2-2";
export var content = "_d2-4";
export var open = "_d2-1";
export var rotate = "_d2-5";